import OrderIcon from '@mui/icons-material/AttachMoney';
import OrganizationList from './OrganizationList';
export default {
    list: OrganizationList,
    icon: OrderIcon,
    recordRepresentation: 'reference',
};
